import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ItemProdutoResumoJanelaRoutingModule } from './item-produto-resumo-janela-routing.module';
import { ItemProdutoResumoJanelaComponent } from './item-produto-resumo-janela.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { TabViewModule } from 'primeng/tabview';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';
import { QRCodeModule } from 'angularx-qrcode';
import { DividerModule } from 'primeng/divider';
import { InputNumberModule } from 'primeng/inputnumber';


@NgModule({
  declarations: [
    ItemProdutoResumoJanelaComponent
  ],
  imports: [
    CommonModule,
    ItemProdutoResumoJanelaRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    InputMaskModule,
    FormatPipeModule,
    TabViewModule,
    ProgressSpinnerModule,
    MessagesModule,
    QRCodeModule,
    DividerModule,
    InputNumberModule
  ]
})
export class ItemProdutoResumoJanelaModule { }
